module.exports = __webpack_public_path__ + "851999716bb1ae6ef252865e2a4f14d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/6.svg
// module id = 701
// module chunks = 0